import { render } from "./AppModal.vue?vue&type=template&id=9ff6f3ce&scoped=true&ts=true"
import script from "./AppModal.vue?vue&type=script&lang=ts"
export * from "./AppModal.vue?vue&type=script&lang=ts"

import "./AppModal.vue?vue&type=style&index=0&id=9ff6f3ce&lang=scss&scoped=true"

import exportComponent from "/tmp/build_c94111dd/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ff6f3ce"]])

export default __exports__